import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import FinancialProductRulesEditDetailsOutputDataContainer from './OutputData/FinancialProductRulesEditDetailsOutputDataContainer';
import FinancialProductRulesEditDetailsOutputDictionariesContainer from './OutputDictionaries/FinancialProductRulesEditDetailsOutputDictionariesContainer';
import FinancialProductRulesEditDetailsServicesContainer from './Services/FinancialProductRulesEditDetailsServicesContainer';
import FinancialProductRulesEditDetailsCommissionsContainer from './Commissions/FinancialProductRulesEditDetailsCommissionsContainer';
import FinancialProductRulesEditDetailsIncomesContainer from './Incomes/FinancialProductRulesEditDetailsIncomesContainer';
import { useTranslation } from 'react-i18next';
import List from '@mui/icons-material/List';
import { NavPillsCardContainer } from 'components/common/Styles';
import { Card } from '@totalsoft/rocket-ui';
import NavPillsWithPrompt from 'features/common/dirtyInfo/components/NavPillsWithPrompt';

const FinancialProductRulesEditDetailsComponent = ({ canWrite, financialProductRule, ruleId, productId }) => {
  const [t] = useTranslation();
  const initialTabItems = useMemo(
    () => [
      {
        label: t('FinancialProduct.Details.Rules.Details.OutputData.Title'),
        content: (
          <FinancialProductRulesEditDetailsOutputDataContainer
            outputDataList={financialProductRule?.outputData}
            isSaved={Boolean(ruleId)}
            canWrite={canWrite}
          />
        )
      },
      {
        label: t('FinancialProduct.Details.Rules.Details.OutputDictionaries.Title'),
        content: (
          <FinancialProductRulesEditDetailsOutputDictionariesContainer
            outputDictionariesList={financialProductRule?.outputDictionaries}
            isSaved={Boolean(ruleId)}
            canWrite={canWrite}
          />
        )
      },
      {
        label: t('FinancialProduct.Details.Rules.Details.Services.Title'),
        content: (
          <FinancialProductRulesEditDetailsServicesContainer
            serviceList={financialProductRule?.services}
            isSaved={Boolean(ruleId)}
            canWrite={canWrite}
          />
        )
      },
      {
        label: t('FinancialProduct.Details.Rules.Details.Commissions.Title'),
        content: (
          <FinancialProductRulesEditDetailsCommissionsContainer
            commissionList={financialProductRule?.commissions}
            isSaved={Boolean(ruleId)}
            canWrite={canWrite}
          />
        )
      },
      {
        label: t('FinancialProduct.Details.Rules.Details.Incomes.Title'),
        content: (
          <FinancialProductRulesEditDetailsIncomesContainer
            incomeList={financialProductRule?.incomes}
            isSaved={Boolean(ruleId)}
            canWrite={canWrite}
            productId={productId}
          />
        )
      }
    ],
    [
      canWrite,
      financialProductRule?.outputData,
      financialProductRule?.commissions,
      financialProductRule?.incomes,
      financialProductRule?.outputDictionaries,
      financialProductRule?.services,
      ruleId,
      productId,
      t
    ]
  );

  return (
    <Card icon={List} iconColor='primary' title={t('FinancialProduct.Details.Header')}>
      <NavPillsCardContainer>
        <NavPillsWithPrompt fullWidth tabs={initialTabItems} />
      </NavPillsCardContainer>
    </Card>
  );
};

FinancialProductRulesEditDetailsComponent.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  financialProductRule: PropTypes.object,
  ruleId: PropTypes.number,
  productId: PropTypes.number
};

export default FinancialProductRulesEditDetailsComponent;
